import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function QuestionAnswerFormTemps({ updateReports, startIcon, open, setOpen }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  let w_tprofile = sessionStorage.getItem('w-tprofile')
  const navigate = useNavigate()

  const [questionanswer, setQuestionanswer] = useState([])
  const [ans, setAns] = useState([])
  const [btnEnable, setBtnEnable] = useState(false)

  const { handleSubmit, reset } = useForm({})

  useEffect(() => {
    fetchQuestionanswer()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
    setAns([])
  }

  const handleClose = () => {
    setOpen(false)
    setAns([])
    reset()
  }

  const onSubmit = async (data) => {
    setBtnEnable(true)
    const payload = {
      ans: ans,
    }

    const response = await makePostRequest(urls.setQuestionaryTempsAnswer, payload, {}, true)
    if (response.status === 200) {
      updateReports()
      handleClose()
      if (w_tprofile) {
        // Do not advance the wizard here; UserWizardPage's TimeProfile popup
        // reads w-tprofile-result on mount, shows the result dialog, and its
        // "Continuer" button calls handleValidateStep to advance.
        sessionStorage.setItem('w-tprofile-result', response.data)
        sessionStorage.removeItem('w-tprofile')
        navigate('/')
      }
    }
    setBtnEnable(false)
  }

  const fetchQuestionanswer = async () => {
    const url = urls.setQuestionaryTemps
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setQuestionanswer(data)
    }
  }

  return (
    <>
      <Box sx={{ cursor: 'pointer' }} onClick={handleClickOpen}>
        {startIcon}
      </Box>
      <Dialog fullWidth maxWidth="sm" className="no-drag" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: '#383838 !important' }}>
          {t('syntheseTemps.timeProfileQuestionnaireTitle')}
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            {questionanswer &&
              questionanswer.map((val, idx) => (
                <div key={idx}>
                  <Typography variant="div" sx={{ fontWeight: '500' }}>
                    {val.question}
                  </Typography>
                  <ComboBox
                    handleAutoComplete={(e, j) => setAns([...ans, j.id])}
                    data={val.ans}
                    required={true}
                  />
                </div>
              ))}
          </DialogContent>
          <DialogActions>
            <Button type="submit" disabled={btnEnable}>
              {t('syntheseTemps.validate')}
            </Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_tprofile) {
                  sessionStorage.removeItem('w-tprofile')
                  navigate('/')
                }
              }}
            >
              {t('syntheseTemps.cancel')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
